import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useForm } from "react-hook-form";
import Paper from "@mui/material/Paper";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import "../components/Table/Table.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopLoader from "../components/Loader/TopLoader";
import {
  getAllBlocksFromDistrict,
  getGPFromDistrictAndBlock,
  getVillageFromGpBlockAndDistrict,
  get_category_for_student,
  get_sub_category_for_student_by_caste,
  getallDistricts,
  getstudentinfo,
  updateStudent,
  get_hostel_type_from_udise,
  get_school_name_gmid,
} from "../api/Users";
import { toast } from "react-toastify";
import { TextField, TablePagination } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Modal, Button, Typography } from "@mui/material";
import { MDBTypography } from "mdb-react-ui-kit";
import adhaarImg from "../images/adhaar.png";
import { Image } from "react-bootstrap";

const StudentDetails = ({ role, mainId, userData }) => {
  const [error, setErrors] = useState({});

  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  // Search and pagination
  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpen1, setModalOpen1] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [castes, setCastes] = useState([]);
  const [stduentid, setStudentid] = useState("");

  const [Allblocks, setAllBlocks] = useState([]);
  const [Block, setBlock] = useState("");
  const [districtDropdown, setDistrictDropdown] = useState("");
  const [Alldistricts, setAllDistricts] = useState([]);
  const [Village, setVillage] = useState("");
  const [GP, setGP] = useState("");
  const [AllGPs, setAllGPs] = useState([]);
  const [Allvillages, setAllVillages] = useState([]);

  const [loading, setLoading] = useState(0);
  const [Subcastes, setSubCastes] = useState([]);
  const location = useLocation();
  const rowData = location.state;
  const [student, setStudent] = useState({
    name: "",
    class: "",
    date_of_birth: "",
    gender: "",
    caste: "",
    sub_caste: 0,
    res_status: "",
    hostel_attached: "",
    school_name: "",
    hostel_type: "",
    father_name: "",
    doj: "",
    mother_name: "",
    guardian_ph_no: "",
    student_aadhaar: "",
    aadhaar1: "",
    aadhaar2: "",
    aadhaar_no: "",
  });

  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [AllHostelTypes, setAllHostelTypes] = useState([]);

  useEffect(() => {
    getallDistricts()
      .then((response) => {
        if (response.status == "success") {
          setAllDistricts(response.data);
        } else {
          setAllDistricts([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });

    get_school_name_gmid(userData.data.gm_id)
      .then((response) => {
        if (response.status == "success") {
          setAllSchoolNames(response.data.new_asset_query);
        } else {
          setAllSchoolNames([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching villages:", error);
      });

    const data = {
      UDISE_code: userData.data.UDISE_code,
    };

    get_hostel_type_from_udise(data).then((res) => {
      if (res.status == "success") {
        setAllHostelTypes(res.data.hostelData);
      } else {
        setAllHostelTypes([]);
      }
    });

    get_category_for_student()
      .then((response) => {
        if (response.status == "success") {
          setCastes(response.data.student_category);
        }
      })
      .catch((error) => {
        console.error("Error fetching villages:", error);
      });
    getStudentDetails();
  }, []);

  const { formState } = useForm();
  const { errors } = formState;

  const [photo, setPhoto] = useState(null);
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    setPhoto(file);
  };

  const handleChangeInput = (e) => {
    const { name, value, type, files } = e.target;
    if (type !== "file") {
      setStudent((student) => ({ ...student, [name]: value }));
    } else {
      const file = files[0];
      setStudent((student) => ({ ...student, [name]: file }));
    }

    if (name === "caste") {
      get_sub_category_for_student_by_casteFunc(value);
    }
  };

  const get_sub_category_for_student_by_casteFunc = (value) => {
    let data = {
      Caste_Category: value,
    };
    get_sub_category_for_student_by_caste(data).then((res) => {
      if (res.status === "success") {
        setSubCastes(res.data.student_sub_category);
      }
    });
  };

  const getAllBlocksFromDistrictFunc = (value) => {
    getAllBlocksFromDistrict(value)
      .then((res) => {
        if (res.status === "success") {
          setAllBlocks(res.data.new_asset_query);
        }
      })
      .catch((err) => {
        console.error("Error fetching blocks:", err);
      });
  };

  const getGPFromDistrictAndBlockFunc = (district, block) => {
    getGPFromDistrictAndBlock(district, block)
      .then((res) => {
        if (res.status === "success") {
          setAllGPs(res.data.new_asset_query);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  const formatDate = (dateStr) => {
    const parts = dateStr.split("-"); // Split the date by '-'
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // Reformat to YYYY-MM-DD
    }
    return ""; // Return empty string if the date is invalid
  };

  const getVillageFromGpBlockAndDistrictFunc = (district, block, GP) => {
    getVillageFromGpBlockAndDistrict(district, block, GP)
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setAllVillages(res.data.new_asset_query);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  };

  const handleDistrictChange = (e) => {
    setDistrictDropdown(e.target.value);
    getAllBlocksFromDistrictFunc(e.target.value);
  };

  const handleBlockChange = (e) => {
    setBlock(e.target.value);
    getGPFromDistrictAndBlockFunc(districtDropdown, e.target.value);
  };

  const handleGPChange = (e) => {
    setGP(e.target.value);
    getVillageFromGpBlockAndDistrictFunc(
      districtDropdown,
      Block,
      e.target.value
    );
  };
  const handleVillageChange = (e) => {
    setVillage(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formErrors = {};
    const namePattern = /^[a-zA-Z\s'-]+$/;

    if (photo == null && !selectedRow.student_photo) {
      formErrors.photo_file = "No student photo selected!";
    }

    if (!student.name.trim() && !selectedRow.student_name.trim()) {
      formErrors.name = "Student Name is required";
    } else if (
      student.name
        ? !namePattern.test(student.name)
        : !namePattern.test(selectedRow.student_name)
    ) {
      formErrors.name = " Student name must contain only letters";
    }

    if (!student.class && !selectedRow.class) {
      formErrors.class = "Class is required";
    }

    if (!student.gender && !selectedRow.Gender) {
      formErrors.gender = "Gender is required";
    }

    if (!student.date_of_birth && !selectedRow.date_of_birth) {
      formErrors.date_of_birth = "Date of Birth is required";
    }

    if (!student.caste && !selectedRow.Caste_Category) {
      formErrors.caste = "Caste is required";
    }

    if (!student.sub_caste && !selectedRow.Sub_Caste) {
      formErrors.sub_caste = "Sub Caste is required";
    }

    if (!student.res_status && !selectedRow.Boarder_Dayscholar) {
      formErrors.res_status = "Residential Status is required";
    }
    if (student.res_status === "Boarder") {
      if (!student.hostel_attached && !selectedRow.hostel_attached_to_school) {
        formErrors.hostel_attached = "Hostel Ownership is required";
      }

      if (!student.school_name && !selectedRow.school_id) {
        formErrors.school_name = "School Name is required";
      }

      if (!student.hostel_type && !selectedRow.hostel_id) {
        formErrors.hostel_type = "Hostel Type is required";
      }

      if (!student.doj && !selectedRow.joining_date_Boarderel) {
        formErrors.doj = "Date Of Joining is required";
      }
    }

    if (!student.father_name.trim() && !selectedRow.father_name.trim()) {
      formErrors.father_name = "Father's Name is required";
    } else if (
      student.father_name
        ? !namePattern.test(student.father_name)
        : !namePattern.test(selectedRow.father_name)
    ) {
      formErrors.father_name = "Father's Name must contain only letters";
    }

    if (!student.mother_name.trim() && !selectedRow.mother_name.trim()) {
      formErrors.mother_name = "Mother's Name is required";
    } else if (
      student.mother_name
        ? !namePattern.test(student.mother_name)
        : !namePattern.test(selectedRow.mother_name)
    ) {
      formErrors.mother_name = "Mother's Name must contain only letters";
    }

    if (
      !student.guardian_ph_no.trim() &&
      !selectedRow.Parents_MobileNo.trim()
    ) {
      formErrors.guardian_ph_no = "Guardian's Mobile Number is required";
    } else if (
      student.guardian_ph_no
        ? !/^\d{10}$/.test(student.guardian_ph_no)
        : !/^\d{10}$/.test(selectedRow.Parents_MobileNo)
    ) {
      formErrors.guardian_ph_no = "Please enter a valid 10-digit mobile number";
    }

    if (!districtDropdown && !selectedRow.Domicile_District) {
      formErrors.district = "Domicile District is required";
    }

    if (!Block && !selectedRow.Domicile_Block) {
      formErrors.block = "Domicile Block is required";
    }

    if (!GP && !selectedRow.Domicile_GP) {
      formErrors.GP = "Domicile GP is required";
    }

    if (!Village && !selectedRow.Domicile_Village) {
      formErrors.Village = "Domicile Village is required";
    }

    if (!student.aadhaar_no.trim() && !selectedRow.std_aadhar_no.trim()) {
      formErrors.aadhaar_no = "Aadhaar Number is required";
    } else if (
      student.aadhaar_no
        ? !/^\d{12}$/.test(student.aadhaar_no)
        : !/^\d{12}$/.test(selectedRow.std_aadhar_no)
    ) {
      formErrors.aadhaar_no = "Please enter a valid 12-digit Aadhaar number";
    }

    if (
      !student.aadhaar1 == null ||
      !student.aadhaar2 == null ||
      student.student_aadhaar == null
    ) {
      toast.error("Aadhaar upload pending!");
    }

    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);

      const formData = new FormData();
      formData.append(
        "student_name",
        student.name ? student.name : selectedRow.student_name
      );
      formData.append(
        "class",
        student.class ? student.class : selectedRow.class
      );
      formData.append(
        "date_of_birth",
        student.date_of_birth
          ? student.date_of_birth
          : selectedRow.date_of_birth
      );
      formData.append(
        "gender",
        student.gender ? student.gender : selectedRow.Gender
      );
      formData.append(
        "caste_category",
        student.caste ? student.caste : selectedRow.Caste_Category
      );
      formData.append(
        "sub_caste",
        student.sub_caste ? student.sub_caste : selectedRow.Sub_Caste
      );
      formData.append(
        "Boarder_Dayscholar",
        student.res_status ? student.res_status : selectedRow.Boarder_Dayscholar
      );
      formData.append(
        "hostel_attached_to_school",
        student.hostel_attached
          ? student.hostel_attached
          : selectedRow.hostel_attached_to_school
      );
      formData.append(
        "If_no_Mention_school_name",
        student.school_name ? student.school_name : selectedRow.school_id
      );
      formData.append(
        "hostel_id",
        student.hostel_type ? student.hostel_type : selectedRow.hostel_id
      );
      formData.append(
        "father_name",
        student.father_name ? student.father_name : selectedRow.father_name
      );
      formData.append(
        "joining_date_Boarderel",
        student.doj ? student.doj : selectedRow.date_of_birth
      );
      formData.append(
        "mother_name",
        student.mother_name ? student.mother_name : selectedRow.mother_name
      );
      formData.append(
        "Parents_MobileNo",
        student.guardian_ph_no
          ? student.guardian_ph_no
          : selectedRow.Parents_MobileNo
      );
      formData.append(
        "Domicile_District",
        student.Domicile_District
          ? student.Domicile_District
          : selectedRow.Domicile_District
      );
      formData.append(
        "Domicile_Block",
        Block ? Block : selectedRow.Domicile_Block
      );
      formData.append("Domicile_Gp", GP ? GP : selectedRow.Domicile_GP);
      formData.append(
        "Domicile_Village",
        Village ? Village : selectedRow.Domicile_Village
      );
      formData.append(
        "student_aadhar_card",
        student.student_aadhaar
          ? student.student_aadhaar
          : selectedRow.student_aadhar_card
      );
      formData.append(
        "father_aadhar_card",
        student.aadhaar1 ? student.aadhaar1 : selectedRow.father_aadhar_card
      );
      formData.append(
        "mother_aadhar_card",
        student.aadhaar2 ? student.aadhaar2 : selectedRow.mother_aadhar_card
      );
      formData.append(
        "std_aadhar_no",
        student.aadhaar_no ? student.aadhaar_no : selectedRow.std_aadhar_no
      );
      formData.append(
        "student_photo",
        photo ? photo : selectedRow.student_photo
      );
      formData.append(
        "student_dob_certificate",
        student.birth_cert
          ? student.birth_cert
          : selectedRow.student_dob_certificate
      );
      
      formData.append(
        "id", stduentid
      );

      updateStudent(formData)
        .then((res) => {
          if (res.status === "success") {
            setIsLoading(false);
            toast.success(t(res.message));
            window.location.reload();
          } else {
            setIsLoading(false);
            toast.error(t(res));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleUpdateClick1 = (row) => {
    setModalOpen1(true);
  };

  const handleCloseModal1 = () => {
    setModalOpen1(false);
  };

  const handleUpdateClick = (row) => {
    setSelectedRow(row);
    setStudentid(row.id);
    getAllBlocksFromDistrictFunc(row.Domicile_District);
    getGPFromDistrictAndBlockFunc(row.Domicile_District, row.Domicile_Block);
    getVillageFromGpBlockAndDistrictFunc(
      row.Domicile_District,
      row.Domicile_Block,
      row.Domicile_GP
    );
    get_sub_category_for_student_by_casteFunc(row.Caste_Category);
    setTimeout(() => {
      setModalOpen(true);
    }, 1000);
  };

  const getStudentDetails = () => {
    setIsLoading(true);
    let data = {
      school_id: userData.data.school_id,
    };
    getstudentinfo(data).then((res) => {
      if (res.status === "success") {
        console.log(res);
        setFilteredData(res.data.student_data);
      } else {
        setRows([]);
        toast.error(t("Something went wrong"));
      }
    });
    setIsLoading(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  let navigate = useNavigate();
  const view = (row) => {
    navigate(`/add-student-details`, { state: row });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-4 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="mb-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Student Details")}</h5>
          <div>
            <button className="btn btn-sm" id="btn" onClick={() => view()}>
              <AddIcon />
              {t("Add Student")}
            </button>
          </div>
        </div>
        <div className="Table mb-6">
          <TableContainer
            component={Paper}
            style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
            className="my-4"
          >
            <Table sx={{ minWidth: 800 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell align="left">Student Name</TableCell>
                  <TableCell align="left">Class</TableCell>
                  <TableCell align="left">Gender</TableCell>
                  <TableCell align="left">Date Of Birth</TableCell>
                  <TableCell align="left">Caste</TableCell>
                  <TableCell align="left">Sub Caste</TableCell>
                  <TableCell align="left">Student Residential Status</TableCell>
                  <TableCell align="left">Hostel Type</TableCell>
                  <TableCell align="left">Date Of Joining</TableCell>
                  <TableCell align="left">Student Hostel Ownership</TableCell>
                  <TableCell align="left">School Name</TableCell>
                  <TableCell align="left">Aadhaar No.</TableCell>
                  <TableCell align="left">Father Name</TableCell>
                  <TableCell align="left">Mother Name</TableCell>
                  <TableCell align="left">
                    Parents/Guardian Mobile No.
                  </TableCell>
                  <TableCell align="left">Domicile District</TableCell>
                  <TableCell align="left">Domicile Block</TableCell>
                  <TableCell align="left">Domicile GP</TableCell>
                  <TableCell align="left">Domicile Village</TableCell>
                  <TableCell align="left">Action</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && filteredData && filteredData.length > 0 && (
                <TableBody style={{ color: "white" }}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {index + 1}
                        </TableCell>
                        <TableCell align="left" style={{ width: "20%" }}>
                          {row.student_name}
                        </TableCell>
                        <TableCell align="left" style={{ width: "10%" }}>
                          {row.class}
                        </TableCell>
                        <TableCell align="left">{row.Gender}</TableCell>
                        <TableCell align="left">{row.date_of_birth}</TableCell>
                        <TableCell align="left">{row.Caste_Category}</TableCell>
                        <TableCell align="left">{row.Sub_Caste}</TableCell>
                        <TableCell align="left">
                          {row.Boarder_Dayscholar}
                        </TableCell>
                        <TableCell align="left">{row.hostel_type}</TableCell>
                        <TableCell align="left">
                          {row.joining_date_Boarderel}
                        </TableCell>
                        <TableCell align="left">
                          {row.hostel_attached_to_school}
                        </TableCell>
                        <TableCell align="left">
                          {row.If_no_Mention_school_name}
                        </TableCell>
                        <TableCell align="left">{row.std_aadhar_no}</TableCell>
                        <TableCell align="left">{row.father_name}</TableCell>
                        <TableCell align="left">{row.mother_name}</TableCell>
                        <TableCell align="left">
                          {row.Parents_MobileNo}
                        </TableCell>
                        <TableCell align="left">
                          {row.Domicile_District}
                        </TableCell>
                        <TableCell align="left">{row.Domicile_Block}</TableCell>
                        <TableCell align="left">{row.Domicile_GP}</TableCell>
                        <TableCell align="left">
                          {row.Domicile_Village}
                        </TableCell>
                        <TableCell align="left">
                          <BorderColorOutlinedIcon
                            style={{ color: "#4eb2e7", cursor: "pointer" }}
                            onClick={() => handleUpdateClick(row)}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              )}
              {selectedRow && (
                <Modal
                  open={modalOpen}
                  onClose={handleCloseModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 1280,
                      backgroundColor: "#ffffff",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: 8,
                      padding: 20,
                      height: 600,
                      overflowY: "scroll",
                    }}
                  >
                    {" "}
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleCloseModal}
                      style={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        background: "none",
                        border: "none",
                        fontSize: 24,
                        cursor: "pointer",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        className="bi bi-x"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                      </svg>
                    </button>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div>
                        <MDBTypography tag="h5" className="">
                          Update Student Details
                        </MDBTypography>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <form
                        onSubmit={(e) => onSubmit(e)}
                        id="myform"
                        style={{ marginTop: "12px" }}
                      >
                        <div className="row">
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Student Photo")}{" "}
                            </label>
                            <input
                              type="file"
                              name="photo_file"
                              accept="image/*"
                              className="form-control"
                              onChange={handlePhotoChange}
                            />
                            {selectedRow.student_photo && (
                              <p className="text-primary">
                                Selected file: {selectedRow.student_photo}
                              </p>
                            )}
                            {error.photo_file && (
                              <div className="text-danger">
                                {error.photo_file}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Student Name")}
                              {""}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              type="text"
                              name="name"
                              className="form-control"
                              onChange={handleChangeInput}
                              defaultValue={selectedRow.student_name}
                              required
                            />
                            {error.name && (
                              <div className="text-danger">{error.name}</div>
                            )}
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              {t("Class")}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="class"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              required
                              defaultValue={selectedRow.class}
                            >
                              <option value="">Select Class</option>
                              <option value="I">I</option>
                              <option value="II">II</option>
                              <option value="III">III</option>
                              <option value="IV">IV</option>
                              <option value="V">V</option>
                              <option value="VI">VI</option>
                              <option value="VII">VII</option>
                              <option value="VIII">VIII</option>
                              <option value="IX">IX</option>
                              <option value="X">X</option>
                              <option value="XI">XI</option>
                              <option value="XII">XII</option>
                            </select>
                            {error.class && (
                              <div className="text-danger">{error.class}</div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Gender")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="gender"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              required
                              defaultValue={selectedRow.Gender}
                            >
                              <option value="">Select Gender</option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                            {error.gender && (
                              <div className="text-danger">{error.gender}</div>
                            )}
                          </div>

                          {/* <div className="row" style={{ marginTop: "12px" }}> */}
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Date of Birth")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              type="date"
                              name="date_of_birth"
                              className="form-control"
                              onChange={handleChangeInput}
                              defaultValue={selectedRow.date_of_birth}
                              required
                            />
                            {error.date_of_birth && (
                              <div className="text-danger">
                                {error.date_of_birth}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Caste")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="caste"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              defaultValue={selectedRow.Caste_Category}
                              required
                            >
                              <option value="">Select Caste</option>
                              {castes.map((caste) => (
                                <option value={caste.Caste_Category}>
                                  {caste.Caste_Category}
                                </option>
                              ))}
                            </select>
                            {error.caste && (
                              <div className="text-danger">{error.caste}</div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Sub Caste")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="sub_caste"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              defaultValue={selectedRow.Sub_Caste}
                              required
                            >
                              <option value="">Select Caste</option>
                              {Subcastes.map((caste) => (
                                <option value={caste.Sub_Caste}>
                                  {caste.Sub_Caste}
                                </option>
                              ))}
                            </select>
                            {error.sub_caste && (
                              <div className="text-danger">
                                {error.sub_caste}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Student Residential Status")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="res_status"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              defaultValue={selectedRow.Boarder_Dayscholar}
                              required
                            >
                              <option value="">
                                Select Residential Status
                              </option>
                              <option value="Day Scholar">Day Scholar</option>
                              <option value="Boarder">Boarder</option>
                            </select>
                            {error.res_status && (
                              <div className="text-danger">
                                {error.res_status}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-4 mt-4"
                            style={{
                              display:
                                student.res_status == "Boarder"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <label className="form-label">
                              {t("Student Hostel Ownership")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="hostel_attached"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              defaultValue={
                                selectedRow.hostel_attached_to_school
                              }
                            >
                              <option value="">Select Hostel Ownership</option>
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                            {error.hostel_attached && (
                              <div className="text-danger">
                                {error.hostel_attached}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-4 mt-4"
                            style={{
                              display:
                                student.res_status == "Boarder" &&
                                student.hostel_attached == "No"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <label className="form-label">
                              {t("School Name")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="school_name"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              defaultValue={selectedRow.school_id}
                            >
                              <option value="">Select School Name</option>
                              {AllSchoolNames &&
                                AllSchoolNames.map((row) => (
                                  <option
                                    key={row.school_id}
                                    value={row.school_id}
                                  >
                                    {" "}
                                    {row.name}
                                  </option>
                                ))}
                            </select>
                            {error.school_name && (
                              <div className="text-danger">
                                {error.school_name}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-4 mt-4"
                            style={{
                              display:
                                student.res_status == "Boarder"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <label className="form-label">
                              {t("Hostel Type")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="hostel_type"
                              onChange={handleChangeInput}
                              className="common-input form-select"
                              defaultValue={selectedRow.hostel_id}
                            >
                              <option value="">Select Hostel Types</option>
                              {AllHostelTypes &&
                                AllHostelTypes.map((row) => (
                                  <option
                                    key={row.hostel_id}
                                    value={row.hostel_id}
                                  >
                                    {" "}
                                    {row.hostel_type}
                                  </option>
                                ))}
                            </select>
                            {error.hostel_type && (
                              <div className="text-danger">
                                {error.hostel_type}
                              </div>
                            )}
                          </div>
                          <div
                            className="col-md-4 mt-4"
                            style={{
                              display:
                                student.res_status == "Boarder"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            <label className="form-label">
                              {t("Date Of Joining")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              type="date"
                              name="doj"
                              className="form-control"
                              onChange={handleChangeInput}
                              defaultValue={selectedRow.joining_date_Boarderel}
                            />
                            {error.doj && (
                              <div className="text-danger">{error.doj}</div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Aadhaar No.")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              onChange={handleChangeInput}
                              type="text"
                              pattern="[0-9]*"
                              name="aadhaar_no"
                              className="form-control"
                              defaultValue={selectedRow.std_aadhar_no}
                              required
                              maxLength={12}
                            />
                            {error.aadhaar_no && (
                              <div className="text-danger">
                                {error.aadhaar_no}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Father Name")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              onChange={handleChangeInput}
                              type="text"
                              name="father_name"
                              className="form-control"
                              defaultValue={selectedRow.father_name}
                              required
                            />
                            {error.father_name && (
                              <div className="text-danger">
                                {error.father_name}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Mother Name")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              onChange={handleChangeInput}
                              type="text"
                              name="mother_name"
                              className="form-control"
                              defaultValue={selectedRow.mother_name}
                              required
                            />
                            {error.mother_name && (
                              <div className="text-danger">
                                {error.mother_name}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Parents/Guardian Mobile No.")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <input
                              onChange={handleChangeInput}
                              type="text"
                              pattern="[0-9]*"
                              name="guardian_ph_no"
                              className="form-control"
                              defaultValue={selectedRow.Parents_MobileNo}
                              required
                              maxLength={10}
                            />
                            {error.guardian_ph_no && (
                              <div className="text-danger">
                                {error.guardian_ph_no}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Domicile District")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="domicile_district"
                              className="common-input form-select"
                              onChange={handleDistrictChange}
                              defaultValue={selectedRow.Domicile_District}
                            >
                              <option value="" selected={true}>
                                {t("Select District")}
                              </option>
                              {Alldistricts &&
                                Alldistricts.map((row) => (
                                  <option
                                    key={row.district_code}
                                    value={row.district_code}
                                  >
                                    {" "}
                                    {row.name}
                                  </option>
                                ))}
                            </select>
                            {error.district && (
                              <div className="text-danger">
                                {error.district}
                              </div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Domicile Block")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="domicile_block"
                              className="common-input form-select"
                              onChange={handleBlockChange}
                              defaultValue={selectedRow.Domicile_Block}
                              required
                            >
                              <option value="">{t("Select Block")}</option>
                              {Allblocks &&
                                Allblocks.map((row, index) => (
                                  <option key={index} value={row.code}>
                                    {row.name}
                                  </option>
                                ))}
                            </select>
                            {error.block && (
                              <div className="text-danger">{error.block}</div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Domicile GP")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="domicile_gp"
                              className="common-input form-select"
                              onChange={handleGPChange}
                              defaultValue={selectedRow.Domicile_GP}
                              required
                            >
                              <option value="">{t("Select GP")}</option>
                              {AllGPs &&
                                AllGPs.map((row, index) => (
                                  <option key={index} value={row.code}>
                                    {row.name}
                                  </option>
                                ))}
                            </select>
                            {error.GP && (
                              <div className="text-danger">{error.GP}</div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label">
                              {t("Domicile Village")}{" "}
                              {<span style={{ color: "red" }}>*</span>}
                            </label>
                            <select
                              name="domicile_village"
                              className="common-input form-select"
                              onChange={handleVillageChange}
                              defaultValue={selectedRow.Domicile_Village}
                              required
                            >
                              <option value="">
                                {t("Select Village Name")}
                              </option>
                              {Allvillages &&
                                Allvillages.map((row, index) => (
                                  <option key={index} value={row.gm_id}>
                                    {row.village_name}
                                  </option>
                                ))}
                            </select>
                            {error.Village && (
                              <div className="text-danger">{error.Village}</div>
                            )}
                          </div>
                          <div className="col-md-4 mt-4">
                            <label className="form-label d-flex justify-content-center">
                              {t("Add Documents (PDF only)")}{" "}
                            </label>
                            <div className="d-flex justify-content-center">
                              <button
                                type="button"
                                className="btn btn-secondary col-md-8"
                                onClick={handleUpdateClick1}
                              >
                                Add
                              </button>
                            </div>
                          </div>
                        </div>

                        <div className="row col-12 mt-5 d-flex justify-content-end">
                          <button
                            type="submit"
                            className="btn btn-primary mx-1 mt-4 btn-sm col-2"
                          >
                            {t("Update")}
                          </button>
                          <button
                            className="btn btn-secondary mx-1 mt-4 btn-sm col-2"
                            onClick={handleCloseModal}
                          >
                            {t("Close")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </Modal>
              )}

              <Modal
                open={modalOpen1}
                onClose={handleCloseModal1}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 1000,
                    backgroundColor: "#ffffff",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: 8,
                    padding: 20,
                  }}
                >
                  {" "}
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModal1}
                    style={{
                      position: "absolute",
                      top: 10,
                      right: 10,
                      background: "none",
                      border: "none",
                      fontSize: 24,
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="currentColor"
                      className="bi bi-x"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                    </svg>
                  </button>
                  <div className="row mt-4 mb-2">
                    <div className="row">
                      <div className="col-6">
                        <Image src={adhaarImg} height="300px" />
                      </div>
                      <div className="col-6">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <MDBTypography tag="h5" className="mb-4">
                              Add Documents (PDF only)
                            </MDBTypography>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6 my-3">
                            <label className="form-label">
                              Student's Aadhaar
                            </label>
                            <input
                              type="file"
                              name="student_aadhaar"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {student.student_aadhaar && (
                              <p className="text-primary">
                                Selected file: {student.student_aadhaar.name}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6 my-3">
                            <label className="form-label">
                              Father's Aadhaar
                            </label>
                            <input
                              type="file"
                              name="aadhaar1"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {student.aadhaar1 && (
                              <p className="text-primary">
                                Selected file: {student.aadhaar1.name}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6 my-3">
                            <label className="form-label">
                              Mother's Aadhaar
                            </label>
                            <input
                              type="file"
                              name="aadhaar2"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {student.aadhaar2 && (
                              <p className="text-primary">
                                Selected file: {student.aadhaar2.name}
                              </p>
                            )}
                          </div>
                          <div className="col-md-6 my-3">
                            <label className="form-label">
                              Student's Birth Certificate
                            </label>
                            <input
                              type="file"
                              name="birth_cert"
                              accept=".pdf"
                              className="form-control"
                              onChange={handleChangeInput}
                            />
                            {student.aadhaar2 && (
                              <p className="text-primary">
                                Selected file: {student.birth_cert.name}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
              {!isLoading && (!filteredData || filteredData.length === 0) && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <h4>
                        <i>No data available</i>
                      </h4>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default StudentDetails;
